import Hero from "./../../images/hero-image1.webp";
import { useCallback } from "react";
import Particles from "react-tsparticles";
import type { Container, Engine } from "tsparticles-engine";
import { loadFull } from "tsparticles";

type Props = {
  theme: boolean;
};
export default function About({ theme }: Props) {
  const particlesInit = useCallback(async (engine: Engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(
    async (container: Container | undefined) => {
      await container;
    },
    []
  );
  return (
    <>
      <section id="about" className="bg-white dark:bg-gray-800 relative">
        <div
          id="tsparticles"
          className="container mx-auto flex px-10 pt-20 md:flex-row flex-col items-center"
        >
          <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              background: {
                color: {
                  value: "bg-gray-900",
                },
              },
              style: { position: "absolute", height: "100%" },
              fpsLimit: 120,
              interactivity: {
                events: {
                  onClick: {
                    enable: false,
                  },
                  onHover: {
                    enable: true,
                    mode: "repulse",
                  },
                  resize: true,
                },
                modes: {
                  repulse: {
                    distance: 50,
                    duration: 0.4,
                  },
                },
              },
              particles: {
                color: {
                  value: "#22c55e",
                },
                links: {
                  color: "#22c55e",
                  distance: 150,
                  enable: true,
                  opacity: 0.7,
                  width: 1,
                },
                collisions: {
                  enable: true,
                },
                move: {
                  direction: "none",
                  enable: true,
                  outModes: {
                    default: "bounce",
                  },
                  random: false,
                  speed: 0.8,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    area: 800,
                  },
                  value: 100,
                },
                opacity: {
                  value: 0.1,
                },
                shape: {
                  type: "circle",
                },
                size: {
                  value: { min: 1, max: 5 },
                },
              },
              detectRetina: true,
            }}
          />
          <div className=" lg:flex-grow md:w-1/2 lg:pr-8 md:pr-8 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 className="z-10 title-font sm:text-4xl text-3xl mb-4 font-medium text-black dark:text-white">
              Hi, I'm Vangel Angov
            </h1>
            <h2 className="z-10 title-font sm:text-3xl text-2xl mb-4 font-medium text-black dark:text-white">
              I love to build amazing apps
            </h2>
            <p
              className={`z-10  ${
                theme ? "text-gradient text-white" : "text-black "
              }  mb-8 leading-relaxed `}
            >
              The past year with full dedication I was able to create some
              amazing apps and websites
            </p>
            <div className="flex justify-center">
              <a
                href="#contact"
                className={`sidebar shadow-lg shadow-gray-500/30  inline-flex ${
                  theme ? "bg-green-500 text-white" : "bg-lightgreen text-dark"
                } border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg relative`}
              >
                Work With Me
              </a>
              <a
                href="#projects"
                className="sidebar shadow-lg shadow-gray-500/30  ml-4 inline-flex text-gray-400  bg-gray-900 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg relative"
              >
                See My Past Work
              </a>
            </div>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 relative">
            <img
              className="object-cover rotate-30 object-center rounded"
              alt="hero"
              src={Hero}
            />
          </div>
        </div>
      </section>
    </>
  );
}
